var TableLooks;
(function (TableLooks) {
  TableLooks["Default"] = 'default';
})(TableLooks || (TableLooks = {}));
export { TableLooks };